import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  const [activeCategory, setActiveCategory] = useState('all');

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="text-center mb-8">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950">
          <Link to="/category/all" className="hover:text-primary-500 transition-colors">漫画分类</Link>
        </h2>
        <p className="mt-2 text-sm text-foreground-500">探索你喜欢的漫画类型，找到属于你的精彩故事</p>
      </div>
      <div className="flex flex-wrap justify-center gap-2">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            onClick={() => setActiveCategory(cat.slug)}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
              activeCategory === cat.slug
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
            }`}
          >
            {cat.name}
          </Link>
        ))}
      </div>
    </section>
  );
}